import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit
} from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { WsService } from '../../shared/services/ws.service';

@Component({
  selector: 'app-order-form-change-tarif',
  templateUrl: './order-form-change-tarif.component.html',
  styleUrls: ['./order-form-change-tarif.component.scss']
})
export class OrderFormChangeTarifComponent implements OnInit, OnDestroy {
  added_value: number;
  amount: number;
  add_tarif_id = null;
  error = {
    msg: null,
    status: false
  };
  in_progress = false;
  message$: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<OrderFormChangeTarifComponent>,
    private cd: ChangeDetectorRef,
    private ws: WsService
  ) {
    this.added_value = data.fare.added_value;
    this.amount = data.fare.amount;
  }

  ngOnInit() {
    this.cd.detectChanges();

    /*this.message$ = this.ws.message.subscribe( data => {
     let res = JSON.parse( data );

     if ( this.add_tarif_id == res.header.data_id && res.header.data_id !== undefined ) {
     if ( res.header.status.toLowerCase() == 'ok' ) {
     this.dialogRef.close( res.data );
     } else {
     this.error.msg = res.data;
     this.error.status = true;
     setTimeout( () => {
     this.error = {
     msg: null,
     status: false
     };
     this.in_progress = false;
     }, 5000 );
     }
     }
     } );*/
  }

  ngOnDestroy() {
    if (this.message$) {
      this.message$.unsubscribe();
    }
  }

  calcAmount(add_val) {
    this.added_value = add_val.target.value;
    this.amount = +this.data.fare.value + +add_val.target.value;
  }

  calcAddVal(amount) {
    this.added_value = +amount.target.value - +this.data.fare.value;
  }

  close() {
    this.dialogRef.close(false);
  }

  update() {
    this.add_tarif_id = 'at_id' + new Date();

    /*this.ws.send( {
     header: {
     type: 'fare',
     action: 'put',
     data_id: this.add_tarif_id
     },
     data: {
     id: this.data.fare.id,
     added_value: this.added_value
     }
     } );*/

    this.dialogRef.close({
      header: {
        type: 'fare',
        action: 'put',
        data_id: this.add_tarif_id
      },
      data: {
        id: this.data.fare.id,
        added_value: this.added_value
      }
    });
    
    this.cd.markForCheck();
    // this.in_progress = true;
  }

  clear() {
    this.add_tarif_id = 'at_id' + new Date();

    this.dialogRef.close({
      header: {
        type: 'fare',
        action: 'put',
        data_id: this.add_tarif_id
      },
      data: {
        id: this.data.fare.id,
        added_value: 0
      }
    });
    this.cd.markForCheck();
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/order-form-change-tarif/order-form-change-tarif.component.ts